import { ShareScreenBase } from "./share-screen-base"
import { getRoomDeeplinkUrl } from "~/common/platform"
import { getMetaContent, getMetaContentMaybe } from "~/common/get-meta-content"
import { ShareMessageFragment, ShareRoomFragment, VerificationLink } from "~/__generated__/graphql"
import { useDocumentTitleDescription } from "~/common/use-document-title"
import { RoomContentCard } from "./room-content-card"

export const ShareMessageScreen = (): JSX.Element => {
  const roomData = getMetaContentMaybe("room-data", { json: true }) as ShareRoomFragment | null
  const messageData = getMetaContentMaybe("message-data", {
    json: true,
  }) as ShareMessageFragment | null

  const appEnvironment = getMetaContent<string>("APP_ENVIRONMENT")
  const deeplinkUrl = roomData?.id ? getRoomDeeplinkUrl(appEnvironment, roomData.id) : undefined
  const title =
    roomData &&
    messageData &&
    messageData.user?.shortDisplayName &&
    `${messageData.user.shortDisplayName} in ${roomData.name}`
  const description = "Join the conversation on ChatBCC"
  useDocumentTitleDescription(title, description)

  return (
    <ShareScreenBase
      verificationLinkType={VerificationLink.RoomShare}
      roomHandle={roomData?.roomHandle}
      roomId={roomData?.id}
      deeplinkUrl={deeplinkUrl}
      renderContent={() =>
        roomData && messageData && <RoomContentCard roomData={roomData} className="max-w-[640px]" />
      }
    />
  )
}

export default ShareMessageScreen
